interface MeetingData {
  id: string;
  scheduledAt: string;
  duration: number;
  location: string;
  notes?: string;
  employer: {
    companyName: string;
  };
}

export const addToCalendar = (calendarType: 'google' | 'apple' | 'microsoft', meetingData: MeetingData, applicantNote?: string) => {
  if (!meetingData) return;

  const meeting = meetingData;
  const startDate = new Date(meeting.scheduledAt);
  const endDate = new Date(startDate.getTime() + meeting.duration);
  
  // Format dates for calendar URLs
  const formatDateForCalendar = (date: Date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const startTimeFormatted = formatDateForCalendar(startDate);
  const endTimeFormatted = formatDateForCalendar(endDate);
  
  const title = encodeURIComponent(`Meeting with ${meeting.employer.companyName}`);
  const description = encodeURIComponent(
    `Meeting with ${meeting.employer.companyName}\n\nLocation: ${meeting.location}${
      meeting.notes ? `\n\nNotes: ${meeting.notes}` : ''
    }${applicantNote ? `\n\nApplicant Note: ${applicantNote}` : ''}`
  );
  const location = encodeURIComponent(meeting.location);

  let calendarUrl = '';

  switch (calendarType) {
    case 'google':
      calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${startTimeFormatted}/${endTimeFormatted}&details=${description}&location=${location}`;
      break;
    case 'apple':
      // Apple Calendar uses .ics file format
      const icsContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Geek//Meeting//EN',
        'BEGIN:VEVENT',
        `UID:${meeting.id}@geek.com`,
        `DTSTART:${startTimeFormatted}`,
        `DTEND:${endTimeFormatted}`,
        `SUMMARY:${title}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${location}`,
        'END:VEVENT',
        'END:VCALENDAR'
      ].join('\r\n');
      
      const blob = new Blob([icsContent], { type: 'text/calendar' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'meeting.ics';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      return;
      
    case 'microsoft':
      calendarUrl = `https://outlook.office.com/calendar/0/deeplink/compose?subject=${title}&startdt=${startDate.toISOString()}&enddt=${endDate.toISOString()}&body=${description}&location=${location}`;
      break;
  }

  if (calendarUrl) {
    window.open(calendarUrl, '_blank');
  }
}; 